import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'inventory-2',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/inventory-2/views/inventory-2-index.vue'),
        redirect: '/inventory-2/inventories',
        children: [
          {
            path: 'location',
            component: () => import('@/app/modules/inventory-2/views/inventory-location.vue'),
          },
          {
            path: 'sku',
            component: () => import('@/app/modules/inventory-2/views/inventory-sku.vue'),
          },
          {
            path: 'inventories',
            meta: {
              layoutFeatures: {
                actionPanelVariant: 'module-header',
                pageControlsTarget: 'end',
                pageControlsShowQuickFilters: true,
                pageControlsQuickFiltersLayout: 'stacked',
                pageControlsVisibilityPlacement: 'action-panel',
              },
            },
            component: () => import('@/app/modules/inventory-2/views/inventory-inventories.vue'),
          },
          {
            path: 'transactions',
            component: () => import('@/app/modules/inventory-2/views/inventory-transactions.vue'),
          },
          {
            path: 'product-locations',
            component: () =>
              import('@/app/modules/inventory-2/views/inventory-product-locations.vue'),
          },
        ],
      },
    ],
  },
];

export default routes;
